var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Retriever } from "../../../../../common";
export class PersonalizedRetriever extends Retriever {
    constructor(baseRetriever, personalizedQueryFactory, userInfoObservable) {
        super();
        this.baseRetriever = baseRetriever;
        this.queryFactory = personalizedQueryFactory;
        this.userInfoObservable = userInfoObservable;
    }
    activate(state) {
        return __awaiter(this, void 0, void 0, function* () {
            this.baseRetriever.activate();
            yield this.userInfoObservable.observe(() => {
                return this.baseRetriever.refresh(state, this.queryFactory);
            });
        });
    }
    deactivate() {
        this.baseRetriever.deactivate();
    }
}
//# sourceMappingURL=PersonalizedRetriever.js.map